var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "reg-wrap"
  }, [_vm.wayType === 'email' ? _c('div', {
    staticClass: "email-inner"
  }, [_c('notice-txt', {
    attrs: {
      "txt": "".concat(_vm.$t(_vm.$loginLangPrefix('userSign.notreg'), {
        name: _vm.name
      }))
    }
  }), _vm._v(" "), _c('password-input', {
    on: {
      "changePassword": _vm.changePasswordHandle,
      "changePasswordError": _vm.changePasswordErrorHandle,
      "btnSure": _vm.send
    }
  }), _vm._v(" "), _c('error-tip', {
    attrs: {
      "txt": _vm.passwordError
    }
  }), _vm._v(" "), _c('code-input', {
    ref: "codeinput",
    attrs: {
      "reg": "reg",
      "name": _vm.name
    },
    on: {
      "changeCode": _vm.changeCodeHandle,
      "changeCodeError": _vm.changeCodeErrorHandle,
      "btnSure": _vm.send
    }
  }), _vm._v(" "), _c('error-tip', {
    attrs: {
      "txt": _vm.codeError
    }
  }), _vm._v(" "), _c('button-wrap', {
    attrs: {
      "has": _vm.actBtn,
      "cover": _vm.cover,
      "txt": _vm.$t(_vm.$loginLangPrefix('userSign.sendEmail'))
    },
    on: {
      "btnSure": _vm.send
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "have"
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.haveaccount')))), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function click($event) {
        return _vm.gotoLogin();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.login'))))])])], 1) : _vm._e(), _vm._v(" "), _vm.wayType === 'm-email' ? _c('div', {
    staticClass: "memail-inner"
  }, [_c('title-txt', {
    attrs: {
      "txt": _vm.$t(_vm.$loginLangPrefix('userSign.signIn'))
    }
  }), _vm._v(" "), _c('desc-txt', {
    attrs: {
      "txt": "".concat(_vm.$t(_vm.$loginLangPrefix('userSign.notreg'), {
        name: _vm.name
      }))
    }
  }), _vm._v(" "), _c('password-input', {
    attrs: {
      "mb": "mb"
    },
    on: {
      "changePassword": _vm.changePasswordHandle,
      "changePasswordError": _vm.changePasswordErrorHandle
    }
  }), _vm._v(" "), _c('error-tip', {
    attrs: {
      "txt": _vm.passwordError,
      "mb": "mb"
    }
  }), _vm._v(" "), _c('code-input', {
    ref: "codeinput",
    attrs: {
      "mb": "mb",
      "reg": "reg",
      "name": _vm.name
    },
    on: {
      "changeCode": _vm.changeCodeHandle,
      "changeCodeError": _vm.changeCodeErrorHandle
    }
  }), _vm._v(" "), _c('error-tip', {
    attrs: {
      "mb": "mb",
      "txt": _vm.codeError
    }
  }), _vm._v(" "), _c('button-wrap', {
    attrs: {
      "mb": "mb",
      "has": _vm.actBtn,
      "cover": _vm.cover,
      "txt": _vm.$t(_vm.$loginLangPrefix('userSign.sendEmail'))
    },
    on: {
      "btnSure": _vm.send
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "have mb"
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.haveaccount')))), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function click($event) {
        return _vm.gotoLogin();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.$loginLangPrefix('userSign.login'))))])])], 1) : _vm._e(), _vm._v(" "), _c('toast-pop', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.toastState,
      expression: "toastState"
    }],
    attrs: {
      "txt": _vm.txt
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };